import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import AdminLayout from './components/layout/AdminLayout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import ProductsPage from './pages/ProductsPage';
import CategoriesPage from './pages/CategoriesPage';
import HeroSlidesPage from './pages/HeroSlidesPage';
import CombosPage from './pages/CombosPage';
import ConsultantsPage from './pages/ConsultantsPage';
import OrdersPage from './pages/OrdersPage';
import CouponsPage from './pages/CouponsPage';
import ContactPage from './pages/ContactPage';
import LegalPagesPage from './pages/LegalPagesPage';
import UsersPage from './pages/UsersPage';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ToastProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<DashboardPage />} />
              <Route path="products" element={<ProductsPage />} />
              <Route path="categories" element={<CategoriesPage />} />
              <Route path="hero-slides" element={<HeroSlidesPage />} />
              <Route path="combos" element={<CombosPage />} />
              <Route path="consultants" element={<ConsultantsPage />} />
              <Route path="orders" element={<OrdersPage />} />
              <Route path="coupons" element={<CouponsPage />} />
              <Route path="contact" element={<ContactPage />} />
              <Route path="legal-pages" element={<LegalPagesPage />} />
              <Route path="users" element={<UsersPage />} />
            </Route>
            <Route path="/" element={<Navigate to="/admin" replace />} />
            <Route path="*" element={<Navigate to="/admin" replace />} />
          </Routes>
        </ToastProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
